var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidestInventory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#134A81"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    transform: "translate(12 14)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.714,
    cy: 2.286,
    r: 1.714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.571 4h10.286a1.714 1.714 0 000-3.429H8.571a1.715 1.715 0 000 3.429z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.714,
    cy: 8,
    r: 1.714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.857 6.286H8.571a1.714 1.714 0 000 3.428h10.286a1.714 1.714 0 100-3.428z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.714,
    cy: 13.714,
    r: 1.714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.857 12H8.571a1.715 1.715 0 000 3.429h10.286a1.714 1.714 0 000-3.429z"
  })))));
}
export default SvgWidestInventory;